import { Modal, Text, Button, Flex } from "@mantine/core";

interface VerifyEmailModalProps {
  opened: boolean;
  onClose: () => void;
  email?: string;
  onContinue?: () => void;
}

export default function VerifyEmailModal({ opened, onClose, email, onContinue }: VerifyEmailModalProps) {
  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    } else {
      onClose();
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Verify Your Email Address"
      centered
      size="md"
      styles={{
        title: {
          fontSize: "18px",
          fontWeight: 600,
        },
      }}
    >
      <Flex direction="column" gap="xl">
        <Text fz="sm" c="slate.6">
          We've sent a verification link to {email ? <strong>{email}</strong> : "your registered email address"}. Verify
          your email to continue using GT Setu.
        </Text>

        <Flex justify="flex-end">
          <Button
            size="md"
            px="xl"
            onClick={handleContinue}
            styles={{
              root: {
                backgroundColor: "#2563EB",
                "&:hover": {
                  backgroundColor: "#1D4ED8",
                },
              },
            }}
          >
            Continue
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
